"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
var Box_1 = __importDefault(require("./Box"));
var Styles_1 = require("./forms/Styles");
var icons_1 = require("../icons");
var Checkbox = function (_a) {
    var id = _a.id, disabled = _a.disabled, color = _a.color, rest = __rest(_a, ["id", "disabled", "color"]);
    return (react_1["default"].createElement(CheckBoxWrapper, null,
        react_1["default"].createElement(HiddenInput, __assign({ type: "checkbox", disabled: disabled, id: id }, rest)),
        react_1["default"].createElement(icons_1.CheckActive, { id: "check-active-" + id, color: color, "data-name": "checked" }),
        react_1["default"].createElement(icons_1.CheckEmpty, { id: "check-empty-" + id, color: color, "data-name": "empty" })));
};
var HiddenInput = styled_components_1["default"].input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), Styles_1.hiddenInput);
var CheckBoxWrapper = styled_components_1["default"](Box_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  svg[data-name='checked'] {\n    display: none;\n  }\n\n  > ", ":disabled {\n    & ~ svg[data-name='empty'] {\n      g {\n        stroke: ", ";\n      }\n    }\n\n    & ~ svg[data-name='checked'] {\n      g {\n        fill: ", ";\n      }\n    }\n  }\n\n  > ", ":focus {\n    & ~ svg[data-name='empty'] {\n      g {\n        stroke: ", ";\n        stroke-width: 2;\n      }\n    }\n  }\n\n  > ", ":checked {\n    & ~ svg[data-name='checked'] {\n      display: inline-block;\n    }\n\n    & ~ svg[data-name='empty'] {\n      display: none;\n    }\n  }\n"], ["\n  ", "\n\n  svg[data-name='checked'] {\n    display: none;\n  }\n\n  > ", ":disabled {\n    & ~ svg[data-name='empty'] {\n      g {\n        stroke: ", ";\n      }\n    }\n\n    & ~ svg[data-name='checked'] {\n      g {\n        fill: ", ";\n      }\n    }\n  }\n\n  > ", ":focus {\n    & ~ svg[data-name='empty'] {\n      g {\n        stroke: ", ";\n        stroke-width: 2;\n      }\n    }\n  }\n\n  > ", ":checked {\n    & ~ svg[data-name='checked'] {\n      display: inline-block;\n    }\n\n    & ~ svg[data-name='empty'] {\n      display: none;\n    }\n  }\n"])), Styles_1.inputWrapper, HiddenInput, styled_system_1.themeGet('colors.borderGray'), styled_system_1.themeGet('colors.borderGray'), HiddenInput, styled_system_1.themeGet('colors.primary'), HiddenInput);
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
    size: 20
};
exports["default"] = Checkbox;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Checkbox.js.map